import React from 'react';
import Stack from '../../atoms/Stack';
import IconWithLabelButton from '../../molecules/Buttons/IconWithLabelButton';
import './edit.scss';
import MuiFaIcon from '../../atoms/MuiFaIcon';

type EditContainerProps = {
  close: () => void;
  save: () => void | Promise<void>;
  delete?: () => void | Promise<void>;
  labels?: {
    save?: string;
    close?: string;
    delete?: string;
  };
  children?: React.ReactNode;
  disabled?: boolean;
};

export default function EditContainer({
  close,
  save,
  delete: handleDelete,
  labels,
  children,
  disabled,
}: EditContainerProps) {
  return (
    <div className="settings__edit__container">
      <div className="settings__edit__toolbar">
        <Stack direction="row" spacing={1} sx={{ flexGrow: 1 }}>
          <IconWithLabelButton
            variant="outlined"
            color="primary"
            onClick={() => {
              save();
            }}
            icon={<MuiFaIcon name="fa-solid fa-save" />}
            iconPosition="start"
            label={labels?.save ?? 'Save'}
            sx={{ textTransform: 'none' }}
            disabled={disabled}
          />
          <IconWithLabelButton
            variant="outlined"
            color="error"
            onClick={close}
            icon={<MuiFaIcon name="fa-solid fa-xmark" />}
            iconPosition="start"
            sx={{ textTransform: 'none' }}
            label={labels?.close ?? 'Close'}
          />
          {handleDelete && (
            <IconWithLabelButton
              variant="outlined"
              color="error"
              onClick={() => {
                handleDelete();
              }}
              icon={<MuiFaIcon name="fa-solid fa-trash" />}
              iconPosition="start"
              label={labels?.delete ?? 'Delete'}
              sx={{ textTransform: 'none' }}
            />
          )}
        </Stack>
      </div>
      <div className="settings__edit__form">{children}</div>
    </div>
  );
}
